export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-label="DAFITEXCHANGE logo">
    <path
      d="M6 8h18c13 0 22 10 22 24S37 56 24 56H6V8zm9 9v30h9c8 0 13-6 13-15s-5-15-13-15h-9z"
      fill="#D3FF24"
    />
    <path
      d="M36 22l7.5 10L36 42h8.5l3.2-4.8L51 42h8.5L52 32l7.5-10H51l-3.3 4.8L44.5 22H36z"
      fill="#D3FF24"
    />
  </svg>
);

export default LogoMark;
